<template>
  <div class="layout-container">
    <!-- 移动端遮罩层 -->
    <div v-if="isMobile && !isSidebarCollapsed" class="mobile-mask" @click="toggleSidebar"></div>

    <div class="sidebar" :class="{ collapsed: isSidebarCollapsed }">
      <div class="sidebar-header">
        <h2 v-show="!isSidebarCollapsed">管理系统</h2>
        <!-- <button class="toggle-btn" @click="toggleSidebar">
          <i class="fas fa-bars"></i>
        </button> -->
      </div>
      <div class="menu-list">
        <router-link v-for="menu in menus" :key="menu.path" :to="menu.path" class="menu-item"
          :title="isSidebarCollapsed ? menu.name : ''">
          <i :class="menu.icon"></i>
          <span v-show="!isSidebarCollapsed">{{ menu.name }}</span>
        </router-link>
      </div>
    </div>
    <div class="main">
      <div class="header">
        <!-- 移动端菜单按钮 -->
        <div class="header-left">
          <button class="toggle-btn" @click="toggleSidebar">
            <i class="fas fa-bars"></i>
          </button>
          <div class="current-page">
            <i :class="currentMenu?.icon"></i>
            <span>{{ currentMenu?.name || '首页' }}</span>
          </div>
        </div>
        <div class="user-info">
          <span>{{ userStore.userInfo.nickname }}</span>
          <button @click="handleLogout" class="logout-btn">退出登录</button>
        </div>
      </div>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout' // 修改为多词组件名
}
</script>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/store/user'
import { logout } from '@/api/user'
import { useNotify } from '@/utils/notify'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const isSidebarCollapsed = ref(false)

const menus = computed(() => {
  const baseMenus = [
    { name: '案件列表', path: '/cases', icon: 'fas fa-file-alt' },
    // { name: '单车数据', path: '/bikes', icon: 'fas fa-bicycle' },
  ]

  // 如果用户是管理员，添加管理菜单
  if (userStore.userInfo.admin) {
    baseMenus.push(
      { name: '账号管理', path: '/accounts', icon: 'fas fa-users' },
      { name: '操作日志', path: '/logs', icon: 'fas fa-history' },
      { name: '文件管理', path: '/files', icon: 'fas fa-folder' }
    )
  }

  return baseMenus
})

const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768
  if (!isMobile.value) {
    isSidebarCollapsed.value = false
  }
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
  // 移动端默认收起菜单
  if (window.innerWidth <= 768) {
    isSidebarCollapsed.value = true
  }
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

const toggleSidebar = () => {
  if (isMobile.value) {
    // 移动端模式下反转当前状态
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  } else {
    // PC端保持原有逻辑
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }
}

const handleLogout = async () => {
  try {
    await logout()
    useNotify.Success('退出成功')
    userStore.clear() // 清除用户信息和token
    router.push('/login')
  } catch (error) {
    useNotify.Error('退出失败')
  }
}

// 计算当前页面信息
const currentMenu = computed(() => {
  return menus.value.find(menu => menu.path === route.path)
})
</script>

<style scoped>
.layout-container {
  min-height: 100vh;
  display: flex;
  background: #000000;
}

.sidebar {
  /* min-width: 250px; */
  width: 250px;
  background: #1b1b1b;
  color: white;
  transition: all 0.3s;
  border-right: 1px solid #2a2a2a;
}

.sidebar.collapsed {
  width: 64px;
}

.sidebar-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.toggle-btn {
  background: transparent;
  border: none;
  color: #ffa31a;
  cursor: pointer;
}

.menu-list {
  padding: 20px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #ffa31a;
  text-decoration: none;
  transition: all 0.3s;
}

.menu-item:hover {
  background: #2a2a2a;
  color: #ff9000;
}

.menu-item i {
  margin-right: 10px;
  width: 24px;
  text-align: center;
}

.main {
  width: 'auto' !important;  /* 使内容占满剩余空间 */
  flex: 1;  /* 使内容占满剩余空间 */
  display: flex;  /* 使内容水平排列 */
  flex-direction: column; /* 使内容垂直排列 */
  overflow-x: hidden !important;  /* 防止内容溢出 */
}

.header {
  width: 100%;
  height: 60px;
  background: #1b1b1b;
  color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.main-content {
  width: auto;
  flex: 1;
  padding: 20px;
  background: #000000;
  color: white;
}

@media (max-width: 768px) {
  .toggle-btn {
    display: block;
    /* 确保移动端显示切换按钮 */
  }

  .main-content {
    width: auto;
    flex: 1;
    padding: 0px;
    background: #000000;
    color: white;
  }

  .sidebar {
    min-width: 150px !important;
    width: 150px !important;
    max-width: 150px !important;
    position: fixed;
    height: 100vh;
    z-index: 1000;
    transform: translateX(-100%);
  }

  .sidebar.collapsed {
    transform: translateX(-100%);
  }

  .sidebar:not(.collapsed) {
    transform: translateX(0);
  }

  .toggle-btn {
    display: none;
    /* 移动端隐藏侧边栏内的切换按钮 */
  }

  .header {
    padding: 0 1rem;
  }

  /* .user-info span { */
  /*display: none;  移动端隐藏用户名 */
  /* } */

  .current-page {
    display: none;
    /* 移动端隐藏当前页面标题 */
  }
}

.mobile-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logout-btn {
  padding: 0.5rem 1rem;
  background: #ffa31a;
  border: none;
  color: #000000;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  margin-left: auto;
  /* Add this to push button to the right */
}

.logout-btn:hover {
  background: #ff9000;
}

.toggle-btn {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: #ffa31a;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn:hover {
  color: #ff9000;
}

.current-page {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ffa31a;
  font-size: 1rem;
}

.current-page i {
  font-size: 1.1rem;
}
</style>
